"use client";

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const getTimeLeft = () => {
  const now = new Date();
  const nextMidnight = new Date();
  nextMidnight.setHours(24, 0, 0, 0);
  const diff = nextMidnight - now;

  return {
    hours: Math.floor(diff / 3600000),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60)
  };
};

const OfferBar = () => {
  const location = useLocation();
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());
  const [visible, setVisible] = useState(true);
  const [showOnScroll, setShowOnScroll] = useState(true);

  /* ---------------- ROUTE VISIBILITY ---------------- */
  useEffect(() => {
    if (location.pathname !== "/") {
      setVisible(false);
      return;
    }
    setVisible(localStorage.getItem("fwpi_offer_closed") !== "true");
  }, [location.pathname]);

  /* ---------------- SCROLL HANDLING ---------------- */
  useEffect(() => {
    const onScroll = () => setShowOnScroll(window.scrollY < 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* ---------------- TIMER ---------------- */
  useEffect(() => {
    if (!visible || !showOnScroll) return;
    const t = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(t);
  }, [visible, showOnScroll]);

  /* ---------------- 🔑 CSS COMPATIBILITY HOOK ---------------- */
  useEffect(() => {
    if (visible && showOnScroll) {
      document.body.classList.add("fwpi-offer-open");
    } else {
      document.body.classList.remove("fwpi-offer-open");
    }

    return () => {
      document.body.classList.remove("fwpi-offer-open");
    };
  }, [visible, showOnScroll]);

  const format = (n) => String(n).padStart(2, "0");
  if (!visible || !showOnScroll) return null;

  return (
    <div className="sticky top-0 z-40 w-full bg-[#171A26]/95 backdrop-blur-md border-b border-white/10 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(110deg, transparent 30%, rgba(255,192,32,0.35) 45%, transparent 60%)",
          backgroundSize: "200% 100%",
          animation: "fwpi-sweep 6s linear infinite"
        }}
      />

      <button
        onClick={() => {
          setVisible(false);
          localStorage.setItem("fwpi_offer_closed", "true");
        }}
        className="absolute right-4 top-2 text-white/50 hover:text-white text-xl z-10"
      >
        ×
      </button>

      <div className="relative max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-center sm:text-left">
          <p className="block sm:hidden text-white text-base font-semibold">
            Unlock Your FWPI Membership
          </p>
          <p className="block sm:hidden text-[#FFC020] text-base font-bold">
            Limited-Time Offer
          </p>

          <p className="hidden sm:block text-white text-base font-medium">
            Unlock Your FWPI Membership —
            <span className="text-[#FFC020] font-semibold">
              {" "}Limited-Time Offer
            </span>
          </p>
        </div>

        <div className="flex items-center gap-4 flex-col md:flex-row">
          <div className="flex gap-2">
            {["hours", "minutes", "seconds"].map((u, i) => (
              <div
                key={i}
                className="relative overflow-hidden bg-[#0f1220] border border-[#FFC020]/40 rounded-xl px-4 py-2 min-w-[64px] text-center shadow-lg shadow-[#FFC020]/0.05"
              >
                <div
                  className="absolute inset-0 opacity-[0.08] pointer-events-none"
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, transparent 25%, rgba(255,192,32,0.6) 45%, transparent 65%)",
                    backgroundSize: "250% 100%",
                    animation: "fwpi-sweep 4s linear infinite"
                  }}
                />

                <p className="relative z-10 text-[#FFC020] text-lg font-extrabold tracking-widest">
                  {format(timeLeft[u])}
                </p>
                <span className="relative z-10 text-[10px] uppercase text-white/70 tracking-widest">
                  {u}
                </span>
              </div>
            ))}
          </div>

          <a
            href="/membership/trainer"
            className="relative overflow-hidden bg-[#FFC020] text-black font-bold px-2 py-2 rounded-full text-[15px] sm:text-base hover:bg-[#ffcd4c] transition"
          >
            <span className="relative z-10">Apply Now</span>
            <span
              className="absolute inset-0 opacity-30"
              style={{
                backgroundImage:
                  "linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.5) 50%, transparent 65%)",
                backgroundSize: "200% 100%",
                animation: "fwpi-sweep 4s linear infinite"
              }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export { OfferBar };
